import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 19.25A9.25 9.25 0 0 0 19.25 10 9.25 9.25 0 0 0 10 .75 9.25 9.25 0 0 0 .75 10 9.25 9.25 0 0 0 10 19.25m.1-3.75a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3.5",
      d: "m5.757 5.757 8.486 8.486"
    }, null, -1)
  ]))]))
}
export default { render: render }